import { wlDatas as ReenergisaData } from '../../constants/wl/reenergisa';
import { wlDatas as ElectyData } from '../../constants/wl/ELECTY';
import { wlDatas as VolttaData } from '../../constants/wl/voltta';

/**
 * Realiza uma consulta na tabela wl-data do Strapi, salvando os dados em um token
 * @param {context}   Context     Quando chamado por um getServerSideProps|getStaticProps
 * @param {req}       Request     Quando chamado por um API
 * @param {res}       Response    Quando chamado por um API
 * @param {keyName}   String|Null Chave para buscar um valor especifico no GraphQL query
 * @returns JSON
 */
export const GetWLData = ({ keyName } = { keyName: '' }) => {
  const wlDatas = getWlData(process.env.COMPANY_KEY);

  if (!wlDatas) {
    return {
      status: false,
      error: true,
      data: 'empty',
    };
  }
  const result = {
    status: true,
    data: wlDatas.attributes,
  };

  return result;
};

const getWlData = (company) => {
  switch (company) {
    case 'ELECTY':
      return ElectyData;
    case 'VOLTTA':
    case 'voltta':
      return VolttaData;
    case 'ENERGISA':
    case '(re)energisa':
    case 'energisa':
    case 'reenergisa':
      return ReenergisaData;
    default:
      console.log({ company });
      return false;
  }
};
